module.exports = __webpack_public_path__ + "static/media/shopping_mooring_marker.470c925c.svg";